import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const gridPadding = 5;
export const participantPinnedTileWidth = 200;

export const HiddenNotPinnedParticipants = styled(Box)({
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});
